import masterDataPOS from "./master-data/pos";
import { FeatureList } from "sentec-core-ts";

export default {
  text: "General Settings",
  key: "menu.generalSettings",
  level: 1,
  items: [
    {
      icon: "mdi-database",
      text: "Master Data",
      level: 2,
      items: masterDataPOS
    },
    {
      icon: "mdi-cog",
      text: "Agent",
      level: 2,
      link: "/agent"
    },
    {
      icon: "mdi-tune",
      key: "menu.fbMenuConfiguration",
      text: "FB Menu Configuration",
      level: 2,
      link: "/fb-menu-configuration",
      featureFlagCode: FeatureList.FbMenuOrder
    },
  ]
};
